var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.noEntry)?_c('div',{staticClass:"num-entries mt-2 mt-md-0 mr-2"},[_vm._v(" "+_vm._s(_vm.displayNumEntries)+" "+_vm._s(_vm.entryName)),(!_vm.singleEntry)?_c('span',[_vm._v(_vm._s(_vm.pluralIndicator))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }